import { render, staticRenderFns } from "./DadosRebanhoReproducao.vue?vue&type=template&id=6e1f1774&scoped=true&"
import script from "./DadosRebanhoReproducao.vue?vue&type=script&lang=js&"
export * from "./DadosRebanhoReproducao.vue?vue&type=script&lang=js&"
import style0 from "./DadosRebanhoReproducao.vue?vue&type=style&index=0&id=6e1f1774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1f1774",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VFlex,VForm,VLayout,VTextField})
